// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Appointment } from './appointment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AppointmentType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  appointmentTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  description3!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  appointments!: Appointment[];
}

